import React from 'react';
import PropTypes from 'prop-types';

import { useGetFulfillmentPlanAmountSummary } from '../hooks/use-calculate-amount-summary';
import CurrencyColumn from '../../../components/columns/currency-column';
import { messages } from './messages';

const ShippingPaidColumn = ({ fulfillmentPlanId }) => {
  const amountSummary = useGetFulfillmentPlanAmountSummary(fulfillmentPlanId);
  if (!amountSummary?.shippingAmount) {
    return '';
  }
  const { value, code } = amountSummary.shippingAmount;

  return <CurrencyColumn currencyCode={code} value={value} />;
};

ShippingPaidColumn.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export const ShippingPaid = {
  getMessageDescriptor: () => messages.shippingPaid,
  id: 'shippingPaid',

  render: (data, { isFirstOfType = true } = {}) => {
    if (!isFirstOfType) {
      return null;
    }

    return <ShippingPaidColumn fulfillmentPlanId={data.id} />;
  },
};
